export default __webpack_public_path__ + "static/media/process-com.2b4be1ff.png";